import Auth from './Auth';
import Base from './Base';
import Games from './Games';
import Pages from './Pages';
import Participants from './Participants';
import Participations from './Participations';

class Api extends Base {
    constructor(opts) {
        const options = {
            ...opts,
        };
        super(options);

        this.auth = new Auth(options);
        this.pages = new Pages(options);
        this.games = new Games(options);
        this.participations = new Participations(options);
        this.participants = new Participants(options);
    }
}

export default Api;
